import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Hero from './Hero';
import FounderSection from './FounderSection';
import FounderFeatures from './FounderFeatures';
import BackerStatusAndRewards from './BackerStatusAndRewards';
import WalletIntegration from './WalletIntegration';
import BackerFeatures from './BackerFeatures';
import RoyaltyPayoutsAndCampaigns from './RoyaltyPayoutsAndCampaigns';
import RWABucksSection from './RWABucksSection';
import Summary from './Summary';
import NewFooter from '../NewFooter';

const TrainingCentrePage = () => {
  useEffect(() => {
    AOS.init({ once: true, duration: 1000 });
  }, []);

  return (
    <div className="training-centre-page">
      <Hero />
      <FounderSection />
      <RWABucksSection />
      <RoyaltyPayoutsAndCampaigns />
      <BackerStatusAndRewards />
      <WalletIntegration />
      <FounderFeatures />
      <BackerFeatures />
      <Summary />
      <NewFooter />
    </div>
  );
};

export default TrainingCentrePage;
